import React from 'react'

const AnalysisIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path d="M9.75 4.875C9.75 5.95078 9.40078 6.94453 8.8125 7.75078L11.7797 10.7203C12.0727 11.0133 12.0727 11.4891 11.7797 11.782C11.4867 12.075 11.0109 12.075 10.718 11.782L7.75078 8.8125C6.94453 9.40312 5.95078 9.75 4.875 9.75C2.18203 9.75 0 7.56797 0 4.875C0 2.18203 2.18203 0 4.875 0C7.56797 0 9.75 2.18203 9.75 4.875ZM2.4375 5.0625V6.5625C2.4375 6.87422 2.68828 7.125 3 7.125C3.31172 7.125 3.5625 6.87422 3.5625 6.5625V5.0625C3.5625 4.75078 3.31172 4.5 3 4.5C2.68828 4.5 2.4375 4.75078 2.4375 5.0625ZM4.3125 2.8125V6.5625C4.3125 6.87422 4.56328 7.125 4.875 7.125C5.18672 7.125 5.4375 6.87422 5.4375 6.5625V2.8125C5.4375 2.50078 5.18672 2.25 4.875 2.25C4.56328 2.25 4.3125 2.50078 4.3125 2.8125ZM6.1875 4.3125V6.5625C6.1875 6.87422 6.43828 7.125 6.75 7.125C7.06172 7.125 7.3125 6.87422 7.3125 6.5625V4.3125C7.3125 4.00078 7.06172 3.75 6.75 3.75C6.43828 3.75 6.1875 4.00078 6.1875 4.3125Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
export default AnalysisIcon;
